import { appHttpClient } from "../../installations/axiosInterfaces";

export const sendFastContactUsNotification = (data) => {
  return appHttpClient.post(`/Notification/Send/Contact/Fast`, data);
};

const notificationService = { sendFastContactUsNotification };
export default notificationService;
